// extracted by mini-css-extract-plugin
module.exports = {"mid":"sponsors_mid__3TT9O","sponsor":"sponsors_sponsor__37xOc","spons":"sponsors_spons__hZKSo"};